<template>
  <section>
    <div class="container fullPage mt-5">
      <div class="row">
        <div class="col-md-4 col-md-offset-4 col-sm-8 col-sm-offset-2">
          <div>
            <div class="form__container">
              <h3>Forgot Password</h3>
              <form v-on:submit.prevent>
                <v-text-field
                  v-model="user.email"
                  color="black"
                  label="Email"
                  required
                  type="email"
                ></v-text-field>

                <button @click="submit">Submit</button>
              </form>
            </div>
            <div class="mt-3 link_section">
              <router-link
                to="/signup"
                class="subheading mt-3"
                v-if="routeName !== 'Signup'"
                >Don't have an account yet? Sign Up
              </router-link>
              <router-link to="/login" class="subheading mt-3" v-else
                >Already a user ? Login
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email, numeric } from "vuelidate/lib/validators";
import lb from "../util/lb";

export default {
  name: "forgot-password",
  mixins: [validationMixin],
  validations: {
    "user.email": { required, email }
  },
  data() {
    return {
      routeName: null,
      user: {
        email: null
      }
    };
  },

  methods: {
    submit() {
      // if(validation){}
      lb.post("/api/GWSUsers/reset", {
        email: this.user.email
      })
        .then(() => {
          this.$toasted.success("Reset email sent to your registered email", {
            duration: 3000,
            position: "bottom-right"
          });
        })
        .catch(e => {
          this.$toasted.error("Oops some error occured!", {
            duration: 2000,
            position: "bottom-right"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.form__container {
  padding: 23px;
  h3 {
    text-align: center;
    background: #fff;
    position: relative;
    bottom: 45px;
  }
  border: 1px #31cc9a solid;
}
.link_section {
  text-align: left;
  a {
    display: block;
  }
}
button {
  color: #fff;
  font-weight: 700;
  background: #31cc9a;
  width: 100%;
  height: 50px;
  font-size: 1.5em;
}
.fullPage {
  min-height: 100vh;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
a {
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  color: #31cc9a;
}
a:hover {
  color: #1a7055;
  text-decoration: none;
}
a:visited {
  color: #31cc9a;
}
/*==========  Mobile First Method  ==========*/

/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {
}

/* Extra Small Devices, Phones */
@media only screen and (min-width: 480px) {
}

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {
}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1200px) {
}

/*==========  Non-Mobile First Method  ==========*/

/* Large Devices, Wide Screens */
@media only screen and (max-width: 1200px) {
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
}

/* Small Devices, Tablets */
@media only screen and (max-width: 768px) {
}

/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
}

/* Custom, iPhone Retina */
@media only screen and (max-width: 320px) {
}
</style>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue